import { MY_FLEET_STATE } from "features/myFleet/constants";
import { useSelector } from "react-redux";
import { RootState } from "store";

export const useSortOrder = () => {
  const sortOrder = useSelector(
    (state: RootState) => state[MY_FLEET_STATE].sortOrder
  );
  return sortOrder;
};
